/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { Colors } from '../../constants/colors';

const Container = styled.div`
  width: 100%;
  position: relative;
  background-color: ${Colors.BLACK_100};
  padding-bottom: 56.25%;
`;

const Placeholder = styled.div`
  color: ${Colors.WHITE_80};
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

function EmptyContent(props) {
  const {
    mediaInformation: { message },
  } = props;
  return (
    <Container>
      <Placeholder id="AssetDetails.MediaContent.EmptyContent">{message}</Placeholder>
    </Container>
  );
}

EmptyContent.propTypes = {
  mediaInformation: PropTypes.object.isRequired, // supplied from Redux
};

const mapStateToProps = (state) => ({
  mediaInformation: state.previewAsset.mediaInformation,
});

export default connect(
  mapStateToProps,
  null,
)(EmptyContent);
